import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';
import { MenuItemModel } from '../models/menu-item.model';

const sharedMenuBar: MenuItemModel[] = [
  {
    Text: 'Home',
    ImagePath: '/assets/images/landing/home.png',
    DestinationPage: '',
  },
  {
    Text: 'Exam Practice',
    ImagePath: '/assets/images/landing/online-workbook.png',
    DestinationPage: 'exam-practice-questions',
  },
  {
    Text: 'Video Solutions',
    ImagePath: '/assets/images/landing/exam-skills-videos.png',
    DestinationPage: 'worked-answer-videos',
  },
  {
    Text: 'Practice Papers',
    ImagePath: '/assets/images/landing/practice-papers.png',
    DestinationPage: 'practice-papers',
  },
  {
    Text: 'Extras',
    ImagePath: '/assets/images/landing/pdfs.png',
    DestinationPage: 'extras',
  }
];

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.ExamPracticeQuestions,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Exam Practice Questions',
    ButtonURL: 'exam-practice-questions',

    MixedOnlineTests: [
      {
        // TODO: verify URL
        MixedOnlineTestUrl: '_revisionhub_opc/MCHQ44/MCHQ44_DigitalWorkbook_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Exam Practice Questions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples, then see how it\'s going with your progress tracker.</p>' +
      '<p>Questions marked: <strong>[[variable1]]</strong></p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'All the questions from your book',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.VideoSolutions,
    IsFreeSample: false,
    IconPath: '/assets/images/landing/exam-skills-videos.png',
    Anchor: '',
    ButtonColour: '#FF9335',
    ButtonCustomClasses: '',
    ButtonText: 'Watch solutions',
    // TODO: verify ButtonURL - valid options for VideoSolutions:
    //   'content-videos'       -> route: products/{code}/content-videos/{subcategory}
    //   'worked-answer-videos' -> route: products/{code}/worked-answer-videos/{subcategory}
    //   'video-solutions'      -> route: products/{code}/video-solutions/{subcategory}
    ButtonURL: 'worked-answer-videos',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Video Solutions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Worked answer videos with lots of advice to help you scoop up every last mark.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Step-by-step exam answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Solutions',
        Intro: '<p>CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book  -  have a go at the questions first and use these videos if you need a bit of extra help.</p>',
        // TODO: populate LeftSections (and RightSections if needed) with video entries:
                LeftSections: [
          {
            Header: 'Section One  -  Number',
            Subcategories: [
              { Name: 'Multiples, Factors and Prime Factors', ShortName: '/multiples-factors-and-prime-factors', Link: 'https://www.youtube.com/embed/IZ5xQ0nHxc4?rel=0&modestbranding=1' },
              { Name: 'Fractions and Recurring Decimals', ShortName: '/fractions-and-recurring-decimals', Link: 'https://www.youtube.com/embed/0zDnFnN4-Hk?rel=0&modestbranding=1' },
              { Name: 'Bounds', ShortName: '/bounds', Link: 'https://www.youtube.com/embed/B_7rRWxECfY?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Two  -  Algebra',
            Subcategories: [
              { Name: 'Powers and Roots', ShortName: '/powers-and-roots', Link: 'https://www.youtube.com/embed/HaYtYa4tk9M?rel=0&modestbranding=1' },
              { Name: 'Manipulating Surds', ShortName: '/manipulating-surds', Link: 'https://www.youtube.com/embed/nR2bLBwNVHs?rel=0&modestbranding=1' },
              { Name: 'Factorising Quadratics', ShortName: '/factorising-quadratics', Link: 'https://www.youtube.com/embed/_V0hD9gbGq8?rel=0&modestbranding=1' },
              { Name: 'Sequences', ShortName: '/sequences', Link: 'https://www.youtube.com/embed/H6_I5CnFxl8?rel=0&modestbranding=1' },
              { Name: 'Graphical Inequalities', ShortName: '/graphical-inequalities', Link: 'https://www.youtube.com/embed/nuQcfIK-nRg?rel=0&modestbranding=1' },
              { Name: 'Simultaneous Equations', ShortName: '/simultaneous-equations', Link: 'https://www.youtube.com/embed/1HODaozEcP4?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Three  -  Graphs',
            Subcategories: [
              { Name: 'Straight Line Graphs', ShortName: '/straight-line-graphs', Link: 'https://www.youtube.com/embed/tlvr1RBpT9U?rel=0&modestbranding=1' },
              { Name: 'Solving Equations Using Graphs', ShortName: '/solving-equations-using-graphs', Link: 'https://www.youtube.com/embed/csqYA_UlsqQ?rel=0&modestbranding=1' },
              { Name: 'Velocity-Time Graphs', ShortName: '/velocity-time-graphs', Link: 'https://www.youtube.com/embed/InXdIfjJvSs?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Four  -  Ratio, Proportion and Rates of Change',
            Subcategories: [
              { Name: 'Ratios', ShortName: '/ratios', Link: 'https://www.youtube.com/embed/bXzg5GeRpQc?rel=0&modestbranding=1' },
              { Name: 'Percentages', ShortName: '/percentages', Link: 'https://www.youtube.com/embed/fSrPvDwMCEk?rel=0&modestbranding=1' },
              { Name: 'Density', ShortName: '/density', Link: 'https://www.youtube.com/embed/xEPaTp8NWuQ?rel=0&modestbranding=1' },
            ],
          },
        ],
                RightSections: [
          {
            Header: 'Section Five  -  Geometry and Measures',
            Subcategories: [
              { Name: 'Geometry', ShortName: '/geometry', Link: 'https://www.youtube.com/embed/Mz-tZHnQk9c?rel=0&modestbranding=1' },
              { Name: 'Circle Geometry', ShortName: '/circle-geometry', Link: 'https://www.youtube.com/embed/9bu8zTwVL64?rel=0&modestbranding=1' },
              { Name: 'Perimeter and Area', ShortName: '/perimeter-and-area', Link: 'https://www.youtube.com/embed/jsql2cZU-AY?rel=0&modestbranding=1' },
              { Name: 'More Enlargements', ShortName: '/more-enlargements', Link: 'https://www.youtube.com/embed/f_36rbkU2pM?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Six  -  Pythagoras and Trigonometry',
            Subcategories: [
              { Name: 'Trigonometry', ShortName: '/trigonometry', Link: 'https://www.youtube.com/embed/7GECvh9WHvA?rel=0&modestbranding=1' },
              { Name: '3D Pythagoras and Trigonometry', ShortName: '/3d-pythagoras-and-trigonometry', Link: 'https://www.youtube.com/embed/1LpR0DYdoNs?rel=0&modestbranding=1' },
              { Name: 'Vectors', ShortName: '/vectors', Link: 'https://www.youtube.com/embed/1TpLHOq1oBY?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Seven  -  Probability and Statistics',
            Subcategories: [
              { Name: 'The AND / OR Rules', ShortName: '/the-and-or-rules', Link: 'https://www.youtube.com/embed/eCH2KPEdPwA?rel=0&modestbranding=1' },
              { Name: 'Sets and Venn Diagrams', ShortName: '/sets-and-venn-diagrams', Link: 'https://www.youtube.com/embed/qCJNA_h-D6s?rel=0&modestbranding=1' },
              { Name: 'Grouped Frequency Tables', ShortName: '/grouped-frequency-tables', Link: 'https://www.youtube.com/embed/8JfgvFR_ods?rel=0&modestbranding=1' },
              { Name: 'Histograms and Frequency Density', ShortName: '/histograms-and-frequency-density', Link: 'https://www.youtube.com/embed/mjDaWUnGHmE?rel=0&modestbranding=1' },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.PracticePapers,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Practice Papers',
    ButtonURL: 'practice-papers',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Practice Papers',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Mark the Practice Papers in your book, or print extra copies if you want another go.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Full exam practice',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '<p>If you\'ve had a go at the Practice Papers in your book and are looking for the answers, you\'ll find them below. Or if you want another go at the papers in exam conditions, you can also download the practice papers and print out extra copies. Good luck!</p>\n' +
      '\n' +
      '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MCHQ44/PDFs/cgp-gcse-maths-ocr-higher-paper-1.pdf"><span style="color:#1494d4;">Higher Paper 1</span></a></p>\n' +
      '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MCHQ44/PDFs/cgp-gcse-maths-ocr-higher-paper-2.pdf"><span style="color:#1494d4;">Higher Paper 2</span></a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MCHQ44/PDFs/cgp-gcse-maths-ocr-higher-paper-3.pdf"><span style="color:#1494d4;">Higher Paper 3</span></a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MCHQ44/PDFs/cgp-gcse-maths-ocr-higher-paper-answers.pdf"><span style="color:#1494d4;">Higher Paper Answers</span></a></p>\n'
        ,
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    ButtonURL: 'extras',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Formula sheets and exam tips.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      // TODO: populate ContentMain with intro text and ContentRight with an image if needed
      HeaderText: 'Extra Useful Bits',
      ContentMain: '<div>'+
        '<p>Here\'s a printable formula sheet, plus tips on what to expect in your Maths exams  -  take your pick!</p>' +
        '<strong>' + 
        '<a href="[[cloudfront_url]]/_revisionhub_opc/MCHQ44/PDFs/cgp-gcse-maths-higher-formula-sheet.pdf"><span style="color:#1494d4;">Printable Formula Sheet</span></a><br />' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/MCHQ44/PDFs/cgp-gcse-maths-exam-tips-and-tricks.pdf"><span style="color:#1494d4;">Exam Tips and Tricks</span></a><br />' +
        '</strong>' +
        '</div>' ,
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Take a look at our helpful FAQs or find out how to get in touch with us if you need some help.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our FAQs',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text:
        '<h2>Frequently Asked Questions</h2>\n' +
      '<h5>What is CGP RevisionHub?</h5>\n' +
      '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Maths Workbooks. Use the Online Workbook, videos and more to make sure you know your stuff for the exams.</p>\n' +
      '<h5>How do I access CGP RevisionHub?</h5>\n' +
      '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.</p>\n' +
      '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
      '<p>You\'ll notice lots of QR codes scattered throughout your book. Give them a scan and you\'ll automatically be taken to the relevant test, video or other revision thingy-ma-jig so you can go over what you\'ve learned!</p>\n' +
      '<h5>My CGP RevisionHub isn\'t working  —  what do I do?</h5>\n' +
      '<p>If you can\'t find the answer in these FAQs, it\'s time to contact our friendly Customer Services team. You could also ask your friendly neighbourhood psychic, but they will charge...</p>\n' +
      '<h5>Do I need an internet connection to use CGP RevisionHub?</h5>\n' +
      '<p>Yes, you do. But you can also download some handy PDF resources to use offline. Nice.</p>\n' +
      '<h5>If I log in on a different device, will all my progress be saved?</h5>\n' +
      '<p>Yep. Just log in on your computer, tablet or phone, and all your progress will be there waiting for you.</p>\n' +
      '<h5>How do I use the Online Workbook?</h5>\n' +
      '<p>All the questions from your book are available to answer again online and you can filter them by type, e.g. Problem Solving. There’s also a QR code on each page of your book that will take you directly to the questions for that page. You’ll mark some of the questions yourself by looking at the answers, and the rest are marked automatically in CGP RevisionHub  -  wow!</p>\n' +
      '<h5>Can I clear my progress so far in CGP RevisionHub and start again?</h5>\n' +
      '<p>You can reset your answers in the Online Workbook any time you like! Just click "Reset your answers" at the bottom of the Your Exam Practice menu page.</p>\n' +
      '<h5>Can I share my test results with other people?</h5>\n' +
      '<p>You can\'t share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where\'s the fun in that?</p>\n' +
      '<h5>What happens when I\'ve answered all the questions?</h5>\n' +
      '<p>Ah, one of life\'s greatest questions  —  what next? We\'d recommend that you keep practising right up until your exams.</p>\n' +
      '<h5>Will I always have access to CGP RevisionHub?</h5>\n' +
      '<p>Once you activate the code in the front of your book, you\'ll have access for three years. And they\'ll be three whole years of bliss, we promise.</p>\n',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP Revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>There\'s plenty more revision where this came from! Take a look at some of our other revision books.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },}
];